<template>
	<div class="transfer-user">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.transfer") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="transfer-main">
			<div class="card">
				<div>{{ $t("transfer.money") }}</div>
				<div>
					<p>{{ walletInfolist.usdtUsedPrice }} USDT</p>
					<p>{{ walletInfolist.trxUsedPrice }} TRX</p>
				</div>
			</div>
			<div class="exchange">
				<img src="../assets/zh.png" alt="" />
			</div>
			<div class="card">
				<div>{{ $t("transfer.account_balance") }}</div>
				<div>
					<p>{{ balanceInfolist.usdtUsedPrice }} USDT</p>
					<p>{{ balanceInfolist.trxUsedPrice }} TRX</p>
				</div>
			</div>
			<div class="exchange-number">
				<van-cell-group inset style="margin: 0">
					<van-field v-model="account" :placeholder="tips1" />
				</van-cell-group>
				<div class="select-icon">
					<p @click="openIconShow">{{ value }}</p>
					<van-icon @click="openIconShow" name="arrow-down" size="24" color="#ffffff" />
					<div class="select-up" v-if="iconShow == true">
						<div @click="changeValue('USDT')">
							<p :class="value == 'USDT' ? 'active' : ''">USDT</p>
							<van-icon name="success" size="24" color="#000000" v-if="value == 'USDT'" />
						</div>
						<div @click="changeValue('TRX')">
							<p :class="value == 'TRX' ? 'active' : ''">TRX</p>
							<van-icon name="success" size="24" color="#000000" v-if="value == 'TRX'" />
						</div>
					</div>
				</div>
			</div>
			<div class="nowLogin">
				<div @click="Immediatelytransfer">
					<p>{{ $t("transfer.Immediately_transfer") }}</p>
				</div>
			</div>
		</div>
		<van-overlay :show="passwordShow" @click="passwordShow = false">
			<div class="passwordShow-wrapper" @click.stop>
				<div class="block">
					<div class="index-view-top">
						<van-icon @click="passwordShow = false" name="cross" size="22" color="#565656" />
						<div class="title" style="font-size: 1rem">{{ $t("transfer.password") }}</div>
						<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
					</div>
					<div class="block-details">{{ $t("transfer.betting") }}</div>
					<div class="block-number">
						<p>{{ account }}</p>
						<p>{{ value }}</p>
					</div>
					<div>
						<van-password-input :value="passwordValue" :gutter="10" :focused="showKeyboard" />
					</div>
				</div>
			</div>
		</van-overlay>
		<van-number-keyboard maxlength="6" v-model="passwordValue" :show="showKeyboard" @blur="showKeyboard = false"
			@input="onInput" />
	</div>
</template>

<script>
import {
	walletInfo, transfer, info
} from "@/utils/request";
export default {
	data() {
		return {
			showKeyboard: false,
			passwordShow: false,
			passwordValue: "", //密码
			options: [{
				value: "USDT",
				label: "USDT",
			},
			{
				value: "TRX",
				label: "TRX",
			},
			],
			value: "TRX",
			account: '',
			walletInfolist: [],
			balanceInfolist: '',
			userInfo: '',
			tips1: this.$t("transfer.number"),//要转移的数量
			tips2: this.$t("transfer.select"),//请选择
			iconShow: false,
		};
	},
	mounted() {
		this.walletInfo()
	},
	methods: {
		openIconShow() {
			this.iconShow = !this.iconShow
		},
		changeValue(item) {
			this.value = item
			this.iconShow = false
		},
		walletInfo() {
			info().then((res) => {
				if (res.code == "200") {
					this.userInfo = res.data;
				}
			});
			walletInfo({ kind: '0' }).then((res) => {
				if (res.code == "200") {
					this.balanceInfolist = res.data;
				}
			});
			walletInfo({ kind: '1' }).then((res) => {
				if (res.code == "200") {
					this.walletInfolist = res.data;
				}
			});
		},
		Immediatelytransfer() {
			this.passwordValue = ''
			if (this.userInfo.payPwdStatus == '1') {
				if (this.account > 0 && this.value) {
					this.passwordShow = true
					this.showKeyboard = true
				} else {

				}
			} else {
				this.$toast(this.$t("phone.jiaoyi"));
				setTimeout(() => {
					this.$router.push('/login?type=pay')
				}, 500);
			}

		},
		onInput(e) {
			if (this.passwordValue == '') {
				this.passwordValue = e.toString()
			}
			this.passwordValue += e.toString()
			if (this.passwordValue.length == 6) {
				this.withdrawCoin()
			}
		},
		withdrawCoin() {
			transfer({
				coin: this.value,
				price: this.account,
				payPassword: this.passwordValue
			}).then((res) => {
				if (res.code == "200") {
					this.$toast(this.$t("phone.caozuo"));
					this.account = ''
				} else {
					this.$toast(res.msg);
				}
				this.passwordShow = false
				this.account = ''
				this.passwordValue = ''
				this.walletInfo()
			});
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/.el-select {
	width: 5.5rem;

	.el-input__inner {
		background: none;
		// background: #161414;
		border: unset !important;
	}
}

.select-icon {
	display: flex;
	align-items: center;
	padding-right: 0.25rem;
	position: relative;

	.select-up {
		position: absolute;
		z-index: 999;
		top: -100px;
		right: 1rem;
		width: 16rem;
		background: #ffffff;
		border-radius: 0.5rem;
		padding: 0.5rem 0;

		.active {
			color: #409EFF !important;
		}

		>div {
			padding: 0.5rem 1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	>p {
		width: 48px;
		font-size: 0.8125rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
	}
}

/deep/ .van-field__control {
	color: #ffffff !important;
}

/deep/ .el-select-dropdown {
	background: #161414;
}

/deep/.van-password-input__security li {
	width: 2.3125rem;
	height: 2.3125rem;
	background: rgba(255, 196, 0, 0.1);
	border-radius: 0.3125rem;
}

.transfer-user {
	width: 100vw;
	height: 100vh;
	background: #0c0b0b;

	.passwordShow-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		padding: 0 1.875rem;

		.block {
			width: 100%;
			height: 11.0625rem;
			background: #161414;
			border-radius: 0.9375rem;

			.block-details {
				font-size: 0.75rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				text-align: center;
			}

			.block-number {
				display: flex;
				align-items: flex-end;
				justify-content: center;
				padding: 0.625rem 0 1rem;

				>p:nth-child(1) {
					font-size: 1.125rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #ffc400;
				}

				>p:nth-child(2) {
					font-size: 0.6875rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #565656;
				}
			}
		}
	}

	.nowLogin {
		padding: 3.75rem 1.875rem 0;
		margin-bottom: 0.9375rem;

		>div {
			width: 100%;
			height: 2.6875rem;
			background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
			border-radius: 1.375rem;
			display: flex;
			align-items: center;
			justify-content: center;

			>p {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #0c0b0b;
			}
		}
	}

	.exchange-number {
		display: flex;
		justify-content: space-between;
		border-radius: 0.25rem;
		height: 2.6875rem;
		border: 0.0625rem solid #272727;
		margin-top: 1.5625rem;
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: unset;
	}



	.van-cell {
		background: none !important;
		// background: #161414;
		//border-radius: 1.375rem;
	}

	.van-cell-group {
		// background: #161414;
		background: none !important;
		border-radius: 1.375rem;
	}

	.transfer-main {
		padding: 0 0.9375rem;

		.exchange {
			display: flex;
			justify-content: center;
			padding: 1rem 0 1.25rem;

			>img {
				width: 1rem;
				height: 1.5rem;
			}
		}

		.card {
			width: 100%;
			background: #110E31;
			border-radius: 0.625rem;

			>div:nth-child(1) {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding: 0.9375rem;
			}

			>div:nth-child(2) {
				display: flex;
				align-items: center;
				justify-content: space-around;
				padding-bottom: 1.25rem;

				>p {
					font-size: 1rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #ffffff;
				}
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/transfer.vue